import { takeEvery, put, select } from 'redux-saga/effects'

import { notify } from 'syft-acp-core/actions/notifications'
import { notificationCall } from 'syft-acp-core/sagas/calls'
import { takeLatestApiCall } from 'syft-acp-core/sagas/helpers'
import { showModal, hideModal } from 'syft-acp-core/store/modals/actions'

import * as types from './action-types'
import { clearBulkUpload } from './actions'
import { saveBulkUpload } from './api'

export function* handleSaveSuccess() {
  // @ts-ignore
  const isConfirmation = yield select(state => state?.agencyBulkUpload?.isConfirmation)

  if (isConfirmation) {
    yield put(hideModal('agencyCoverageImportModal'))
    yield put(clearBulkUpload())
    yield put(
      notify('success', {
        title: 'Coverage changes submitted',
        message: 'Changes are being applied in the background and will take effect shortly.',
        autoDismiss: 0,
      }),
    )
  } else {
    yield put(showModal('agencyCoverageImportModal'))
  }
}
export default function* saga() {
  yield takeLatestApiCall(types.AGENCY_COVERAGE_BULK_UPLOAD_SAVE_BEGIN, saveBulkUpload)
  yield takeEvery(types.AGENCY_COVERAGE_BULK_UPLOAD_SAVE_SUCCEEDED, handleSaveSuccess)
  yield takeEvery(types.AGENCY_COVERAGE_BULK_UPLOAD_SAVE_FAILED, notificationCall)
}
